<div class="RateMovie" fxLayout="column" fxLayoutGap="20">
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="column" fxLayoutGap="50px">
      <div mat-dialog-title fxLayout="column">
        <h2 class="heading">My Ratings</h2>
        <span class="sub-title">(1 = poor; 10 = Great)</span>
      </div>
    </div>

    <button mat-button mat-dialog-close class="btn-close">X</button>
  </div>

  <mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="center">
      <form
        *ngIf="NotRated"
        class="content"
        [formGroup]="loanApplicationForm"
        fxLayout="row"
        fxLayoutAlign="space-around"
      >
        <div><input type="number" #box name="name" min="0" max="10" onKeyUp="if(this.value>10){this.value='10';}else if(this.value<0){this.value='0';}" />/10</div>

        <button
          class="btnclose"
          (click)="rateMovie(box.value)"
          *ngIf="NotRated"
        >
          Rate
        </button>
      </form>
      <div *ngIf="Rated" class="content">
        You Have rated {{ displayRatings }} for this Movie
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button mat-button mat-dialog-close class="btnclose">Close</button>
  </mat-dialog-actions>
</div>
